import React from 'react';
import { Button, Tooltip, Space } from 'antd';
import {
  UserSwitchOutlined,
  EditOutlined,
  EyeOutlined,
  StopOutlined,
  CheckCircleOutlined,
  PauseCircleOutlined,
  CrownOutlined,
} from "@ant-design/icons";

const UserActions = ({
  currentUser,
  user,
  onView,
  onEdit,
  onChangeStatus,
  onImpersonate,
  onAssignPlan,
}) => {
  const isSuperAdmin = currentUser?.user.role === 'super_admin';

  const isActive = user.user_status === "active";
  const isDeactivated = user.user_status === "deactivate";
  const isSuspended = user.user_status === "suspended";

  return (
    <Space wrap>
      {/* Impersonate - only for active users */}
      <Tooltip title="Impersonate User">
        <Button
          type="primary"
          icon={<UserSwitchOutlined />}
          size="small"
          disabled={!isActive}
          onClick={onImpersonate}
        >
          Impersonate
        </Button>
      </Tooltip>

      {/* View */}
      <Tooltip title="View Details">
        <Button icon={<EyeOutlined />} size="small" onClick={onView} />
      </Tooltip>

      <Tooltip title="Assign Subscription Plan">
        <Button
          icon={<CrownOutlined />}
          size="small"
          onClick={onAssignPlan}
        />
      </Tooltip>

      {isSuperAdmin && (
        <>
          {/* Edit - available for all users */}
          <Tooltip title="Edit User">
            <Button
              icon={<EditOutlined />}
              size="small"
              onClick={onEdit}
            />
          </Tooltip>

          {/* Status Management Buttons */}
          
          {/* For Active Users: Show Deactivate and Suspend */}
          {isActive && (
            <>
              <Tooltip title="Deactivate User">
                <Button
                  icon={<PauseCircleOutlined />}
                  danger
                  size="small"
                  onClick={() => onChangeStatus("deactivate")}
                />
              </Tooltip>
              <Tooltip title="Suspend User">
                <Button
                  icon={<StopOutlined />}
                  danger
                  size="small"
                  onClick={() => onChangeStatus("suspended")}
                />
              </Tooltip>
            </>
          )}

          {/* For Deactivated Users: Show Activate and Suspend */}
          {isDeactivated && (
            <>
              <Tooltip title="Activate User">
                <Button
                  icon={<CheckCircleOutlined />}
                  type="primary"
                  size="small"
                  onClick={() => onChangeStatus("active")}
                />
              </Tooltip>
              <Tooltip title="Suspend User">
                <Button
                  icon={<StopOutlined />}
                  danger
                  size="small"
                  onClick={() => onChangeStatus("suspended")}
                />
              </Tooltip>
            </>
          )}

          {/* For Suspended Users: Show Activate and Deactivate */}
          {isSuspended && (
            <>
              <Tooltip title="Activate User">
                <Button
                  icon={<CheckCircleOutlined />}
                  type="primary"
                  size="small"
                  onClick={() => onChangeStatus("active")}
                />
              </Tooltip>
              <Tooltip title="Deactivate User">
                <Button
                  icon={<PauseCircleOutlined />}
                  danger
                  size="small"
                  onClick={() => onChangeStatus("deactivate")}
                />
              </Tooltip>
            </>
          )}
        </>
      )}
    </Space>
  );
};

export default UserActions;